module.exports = __webpack_public_path__ + "static/media/jenniifar26_1596517957311.03562776.png";